/*
 * @Author: zxf
 * @Date: 2022-07-20 14:23:00
 * @LastEditors: cgh
 * @LastEditTime: 2022-09-06 11:45:38
 * @Description: 维保项目管理服务
 */
import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;
export const xfwbglService = {

  // 获取维保人员列表
  getWbryList: (params) => { return axios.get(`${iffApi}/common/wbry`, { params: params }); },

  // 获取技术负责人列表
  getJsfzrList: () => { return axios.get(`${iffApi}/common/jsfzr`); },

  // 获取项目负责人列表
  getXmfzrList: () => { return axios.get(`${iffApi}/common/xmfzr`); },

  // 获取附属单位列表
  getFsdwList: () => { return axios.get(`${iffApi}/common/fsdw`); },

  // 获取维保内容列表
  getWbnrList: () => { return axios.get(`${iffApi}/common/wbnr`); },

  // 获取重点企业列表
  getZdqyList: () => { return axios.get(`${iffApi}/common/zdqy`); },

  // 获取维保进度步骤数
  // getStepStatus: () => { return axios.get(`${iffApi}/common/wbjd`); },

  // 获取“合同有效”客户列表
  getYxkhList: () => { return axios.get(`${iffApi}/wbkh/htyxkh`); }

};
